// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[data-v-117284ae]{--tw-border-opacity:1;--tw-text-opacity:1;align-items:center;border-color:#f1832f;border-color:rgb(241 131 47/var(--tw-border-opacity));border-radius:9999px;border-width:2px;color:#f1832f;color:rgb(241 131 47/var(--tw-text-opacity));display:flex;font-size:.875rem;font-weight:600;height:2.5rem;padding-left:1rem;padding-right:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
